__turbopack_context__.v({
  "counterSlot": "wdh5kq_counterSlot",
  "list": "wdh5kq_list",
  "root": "wdh5kq_root",
  "tab": "wdh5kq_tab",
  "tabLabel": "wdh5kq_tabLabel",
  "tabSection": "wdh5kq_tabSection",
  "visuallyHidden": "wdh5kq_visuallyHidden",
});
